import { Asset } from "~/Asset";
import * as Driver from "~/Driver";
import * as ELD from "~/ELD";
import { Order } from "~/Order";
import { Time } from "~/Time";

export type Type = ReturnType<
  | typeof dateOfSubmission
  | typeof submittedBy
  | typeof driver
  | typeof reportDateRange
  | typeof sentTo
  | typeof assets
  | typeof submissionStatus
  | typeof resend
  | typeof reference
>;

export const dateOfSubmission = () => "DATE_OF_SUBMISSION" as const;
export const submittedBy = () => "SUBMITTED_BY" as const;
export const driver = () => "DRIVER" as const;
export const reportDateRange = () => "REPORT_DATES" as const;
export const sentTo = () => "SENT_TO" as const;
export const assets = () => "ASSETS" as const;
export const submissionStatus = () => "STATUS" as const;
export const resend = () => "RESEND" as const;
export const reference = () => "REFERENCE" as const;

export const toOrdering = (type: Type): Order<ELD.ELD> =>
  Order.fromCompare((a, b) => {
    switch (type) {
      case dateOfSubmission():
        return ELD.compare(a, b);
      case submittedBy():
        return ELD.Submission.Submitter.compare(
          a.submission.submitter,
          b.submission.submitter
        );
      case driver():
        return Driver.compare(a.driver, b.driver);
      case reportDateRange():
        return Time.Interval.compare(a, b);
      case assets():
        return Order.optionally(Asset.compare)(a.assets[0], b.assets[0]);
      case sentTo():
        return Order.optionally(Order.string().compare)(a.sentTo, b.sentTo);
      case submissionStatus():
        return ELD.Submission.Status.compare(
          a.submission.status,
          b.submission.status
        );
      case resend():
        return ELD.Submission.Status.compare(
          a.submission.status,
          b.submission.status
        );
      case reference():
        return Order.optionally(Order.string().compare)(
          a.reference,
          b.reference
        );
    }
  });
